/** The film-stock catalogue (admin_handler's film_stocks.rs). Admin only. */
import { api } from './client';

export type FilmProcess = 'c41' | 'bw' | 'e6' | 'other';
export type FilmFormat = '35mm' | '120';

export interface ShopFilmProduct {
  format: FilmFormat;
  product_id: string;
}

export interface FilmStock {
  stock_id: string;
  brand: string;
  name: string;
  /** The speed on the box; missing for a range such as "100-400". */
  box_iso?: number;
  process: FilmProcess;
  formats: FilmFormat[];
  /** Other names it's searched by: earlier names, rebrands, the shop's name. */
  aliases: string[];
  dx_codes: string[];
  /** Shop products selling it; empty when the shop doesn't stock it. */
  shop_products: ShopFilmProduct[];
  /** `shop`, `wikipedia`, `dx` (the starter list) or `admin`. */
  sources: string[];
  /** Turned-off stocks stay on rolls but leave the picker. */
  active: boolean;
  created_at: string;
  updated_at: string;
}

/** What the admin form sends. `active` is for edits only. */
export interface FilmStockInput {
  brand: string;
  name: string;
  box_iso: number | null;
  process: FilmProcess;
  formats: FilmFormat[];
  aliases: string[];
  active?: boolean;
}

/** A 409 from add or edit: the stock that already has that name. */
export interface DuplicateStockBody {
  error: string;
  stock_id: string;
}

export function isDuplicateStockBody(body: unknown): body is DuplicateStockBody {
  return !!body && typeof body === 'object' && 'stock_id' in body && typeof body.stock_id === 'string';
}

const BASE = '/api/v1/admin/film-stocks';

export const filmStocks = {
  list: () => api.get<{ stocks: FilmStock[] }>(BASE).then((r) => r.stocks),
  create: (input: FilmStockInput) => api.post<{ stock: FilmStock }>(BASE, input).then((r) => r.stock),
  update: (stockId: string, input: FilmStockInput) =>
    api.put<{ stock: FilmStock }>(`${BASE}/${encodeURIComponent(stockId)}`, input).then((r) => r.stock),
  /** Load the starter list: adds missing stocks, never changes edited ones. */
  seed: () => api.post<{ added: number; refreshed: number }>(`${BASE}/seed`),
};
